/**
 * VSeparator registration: the parser. It reuses the Control parse, and property knowledge lives
 * in linterParser.ts. The native (WebGL canvas) painter and minimum-size solver register from
 * `index.r3f.ts` (ADR-0001).
 */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseControl } from '../control/parser';
const vSeparatorRegistration = {
    typeName: 'VSeparator',
    parser: parseControl,
};
nodeRegistry.register(vSeparatorRegistration);
//# sourceMappingURL=index.js.map